import { compose } from "ramda";

import { App } from "./App";
import { withRedux } from "./withRedux";
import { withSnackbar } from "./withSnackbar";

export default compose(
  withSnackbar,
  withRedux,
)(App);